import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { homeCardHover, homeSectionPaper } from "../home/homeStyles";
import { communityMatchupPath, publicMatchupPath } from "../../utils/community";
import VoteBar from "./VoteBar";

const MatchupCard = ({ matchup, sport, publicView = false }) => {
  if (!matchup) return null;
  const to = publicView
    ? publicMatchupPath(matchup)
    : communityMatchupPath(sport, matchup.id);

  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        ...homeSectionPaper,
        ...homeCardHover,
        textDecoration: "none",
        color: "inherit",
        p: 2,
        display: "block",
      }}
    >
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: "0.12em" }}>
        Roster battle
      </Typography>
      <Typography variant="h6" fontWeight={800} sx={{ mt: 0.5, mb: 2 }}>
        {matchup.rosterA?.title} vs {matchup.rosterB?.title}
      </Typography>
      <VoteBar matchup={matchup} />
    </Box>
  );
};

export default MatchupCard;
